/**
 * Roleta WHATS — variação inline da roleta de descontos.
 *
 * Herda meno-aliv-wheel (mesmo card, mesma roda, prêmio decidido pelo servidor
 * em POST /api/wheel/spin) e muda só: card fixo na página, campo de e-mail
 * enviado como lead para /api/wheel/lead e CTA para o grupo do WhatsApp.
 * Carregar depois de meno-aliv-wheel.js e roleta-view.js.
 */
(function () {
  if (!window.MenoAlivWheel || !window.RoletaWhatsView) return;
  if (window.__ROLETA_WHATS_DEFINED__) return;
  window.__ROLETA_WHATS_DEFINED__ = true;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const EMAIL_INVALID = 'Por favor, insira um e-mail válido';

  class RoletaWhats extends window.MenoAlivWheel {
    constructor() {
      super();
      this.rootElementId = 'roleta-whats-root';
      this.state.isOpen = true; // o card inline está sempre visível
      this.state.email = '';
      this.state.emailError = '';
      this._whatsRedirectTimeoutId = null;
    }

    loadConfig() {
      super.loadConfig();
      const root = document.getElementById(this.rootElementId);
      const d = (root && root.dataset) || {};
      this.config.leadEndpoint = d.leadEndpoint || '';
      this.config.whatsappUrl = d.whatsappUrl || '';
      this.config.redirectDelay = Number(d.redirectDelay || 0);
      this.config.emailLabel = d.emailLabel || 'E-mail *';
      this.config.emailPlaceholder = d.emailPlaceholder || 'seu@email.com';
      this.config.ctaLabel = d.ctaLabel || 'Entrar no grupo do WhatsApp';
      this.config.resultNote = d.resultNote || 'Entre no grupo VIP para resgatar seu prêmio.';
    }

    /* --- Comportamentos que só fazem sentido no modal --- */
    checkAutoOpen() {}
    setupKeyboardHandlers() {}
    removeKeyboardHandlers() {}
    lockBodyScroll() {}
    unlockBodyScroll() {}
    focusFirstInModal() {}
    closeModal() {}

    clearAllTimeouts() {
      super.clearAllTimeouts();
      if (this._whatsRedirectTimeoutId != null) clearTimeout(this._whatsRedirectTimeoutId);
      this._whatsRedirectTimeoutId = null;
    }

    /* --- Render: card inline + campo de e-mail --- */
    render() {
      super.render();
      const modal = this.shadowRoot.querySelector('.meno-aliv-modal');
      if (modal) modal.classList.add('is-inline');
      this.injectEmailField();
    }

    injectEmailField() {
      const phoneInput = this.shadowRoot.querySelector('#phone-input');
      const group = phoneInput && phoneInput.closest('.form-group');
      if (!group) return;
      // E-mail antes do telefone: o campo do telefone vem do componente base,
      // então a ordem é definida aqui, na inserção.
      group.insertAdjacentHTML('beforebegin', this.emailFieldMarkup());
    }

    /* --- Eventos próprios --- */
    setupEventDelegation() {
      super.setupEventDelegation();
      this._onEmailInput = (e) => {
        if (!e.target || e.target.id !== 'email-input') return;
        this.state.email = e.target.value;
        if (this.state.emailError) this.setEmailError('');
      };
      // Fase de captura: aqui o .cta-btn é um link para o WhatsApp, não o botão
      // da base que aplica cupom no carrinho e fecha o modal.
      this._onCtaCapture = (e) => {
        if (e.target.closest && e.target.closest('.cta-btn')) e.stopImmediatePropagation();
      };
      this.shadowRoot.addEventListener('input', this._onEmailInput);
      this.shadowRoot.addEventListener('click', this._onCtaCapture, true);
    }

    removeEventDelegation() {
      super.removeEventDelegation();
      if (!this.shadowRoot) return;
      this.shadowRoot.removeEventListener('input', this._onEmailInput);
      this.shadowRoot.removeEventListener('click', this._onCtaCapture, true);
    }

    setEmailError(message) {
      this.state.emailError = message;
      const input = this.shadowRoot.querySelector('#email-input');
      const group = input && input.closest('.form-group');
      if (!group) return;
      const existing = group.querySelector('.error-text');
      input.classList.toggle('error', !!message);
      if (!message) {
        input.removeAttribute('aria-invalid');
        if (existing) existing.remove();
        return;
      }
      input.setAttribute('aria-invalid', 'true');
      if (existing) existing.textContent = message;
      else group.insertAdjacentHTML('beforeend', this.emailErrorMarkup(message));
    }

    /* --- Giro: valida o e-mail antes do fluxo padrão --- */
    async handleSpin() {
      if (this.isSpinning) return;
      if (!this.captureEmail()) return;
      await super.handleSpin();
    }

    captureEmail() {
      if (this.state.spinAgainMode) return true; // e-mail já capturado no 1º giro
      const input = this.shadowRoot.querySelector('#email-input');
      if (!input) return false;
      this.state.email = (input.value || '').trim();
      const valid = EMAIL_RE.test(this.state.email);
      this.setEmailError(valid ? '' : EMAIL_INVALID);
      if (!valid) input.focus();
      return valid;
    }

    /* --- Resultado: registra o lead e manda para o grupo --- */
    handlePrizeWon(result) {
      this.sendLead(result);
      super.handlePrizeWon(result);
      this.scheduleWhatsRedirect();
    }

    handleAlreadyParticipated(body) {
      super.handleAlreadyParticipated(body);
      if (this.state.step !== 'result') return;
      this.sendLead(this.state.prize);
      this.scheduleWhatsRedirect();
    }

    sendLead(prize) {
      if (!this.config.leadEndpoint || !this.state.email || !this.state.phone) return;
      const payload = {
        email: this.state.email,
        // Cru, com a máscara — o backend normaliza. É o mesmo valor que vai no /spin.
        phone: this.state.phone,
        shop: this.config.shopDomain,
        page: window.location.pathname || '/',
        prize: (prize && prize.label) || ''
      };
      const utm = this.getUtmParams();
      if (utm) payload.utm = utm;
      fetch(this.config.leadEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(() => {});
    }

    scheduleWhatsRedirect() {
      const { whatsappUrl, redirectDelay } = this.config;
      if (!whatsappUrl || !(redirectDelay > 0)) return;
      this._whatsRedirectTimeoutId = setTimeout(() => {
        this._whatsRedirectTimeoutId = null;
        window.location.href = whatsappUrl;
      }, redirectDelay * 1000);
    }
  }

  // Markup (mesmas classes do meno-aliv-wheel.css) vem de roleta-view.js
  Object.assign(RoletaWhats.prototype, window.RoletaWhatsView);

  customElements.define('roleta-whats', RoletaWhats);
})();
